function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isArray } from '@cloud-sn/v-utils';
import { maybeAncestorOf } from '../util';
export default {
  methods: {
    canAsync: function canAsync(parent) {
      var isLazy = this.isLazy;

      if (!parent) {
        return isLazy;
      }

      var children = parent.children,
          isParent = parent.isParent,
          isLoaded = parent.isLoaded,
          isLoading = parent.isLoading;
      return isLazy && isParent && !isLoading && !isLoaded && (!isArray(children) || children.length === 0);
    },
    // 判断某个未匹配到的valuePath是否可能为未加载节点的valuePath
    isUnMatchedValuePending: function isUnMatchedValuePending() {
      var valuePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var getNode = this.getNode;
      return valuePath.length > 0 && !valuePath.some(function (val, i) {
        if (i === 0) {
          return !getNode([valuePath[0]]);
        }

        var parent = getNode(valuePath.slice(0, i));
        var current = getNode(valuePath.slice(0, i + 1)); // 上一级存在但是下一级不存在

        return parent && parent.isLoaded && !current;
      });
    },
    // 检查pendingValue有效性
    checkPendingValue: function checkPendingValue(parent) {
      var getPendingValue = this.getPendingValue,
          isUnMatchedValuePending = this.isUnMatchedValuePending,
          setPendingValue = this.setPendingValue,
          getNode = this.getNode;
      var pendingValue = getPendingValue();
      var len = pendingValue.length;
      pendingValue = pendingValue.filter(function (val) {
        return !getNode(val) && (parent && !maybeAncestorOf(parent.valuePath, val) || isUnMatchedValuePending(val));
      }); // pendingValue变化了才去更新

      if (len !== pendingValue.length) {
        setPendingValue(pendingValue);
      }
    },
    asyncNode: function asyncNode(parent) {
      var canAsync = this.canAsync,
          loadData = this.loadData,
          addNodes = this.addNodes,
          checkPendingValue = this.checkPendingValue;

      if (!canAsync(parent)) {
        return Promise.resolve(null);
      }

      var nParent = parent;
      var params;

      if (nParent) {
        nParent.isLoaded = false;
        nParent.isLoading = true;
        params = _objectSpread({}, nParent);
      }

      return Promise.resolve(loadData(params)).then(function (data) {
        if (nParent) {
          nParent.isLoaded = true;
          nParent.isLoading = false;
        }

        var result = addNodes(data || [], nParent); // 检查pendingValue有效性

        checkPendingValue(nParent);
        return result;
      }).catch(function () {
        if (nParent) {
          nParent.isLoaded = false;
          nParent.isLoading = false;
        }
      });
    }
  }
};